export default String.raw`
{% if include == 'offer' -%}
	{% assign order = customer-profile.Offer -%}
	{% assign vatValue = order.VatValue -%}
    {% assign DepositValue = order.DepositValue -%}
{% elseif include -%}
	{% assign order = include -%}
	{% assign vatValue = order.ProductsVatValue -%}
	{% assign deliveryCost = order.Delivery.TotalValue -%}
	{% assign paymentCost = order.Payment.TotalValue -%}
	{% assign notDeterminedDeliveryCost = false -%}
    {% assign DepositValue = order.TotalDepositValue -%}
{% else -%}
	{% assign vatValue = order.VATValue -%}
	{% assign deliveryCost = order.SelectedDelivery.TotalValue -%}
	{% assign paymentCost = order.SelectedDelivery.Payment.TotalValue -%}
    {% assign notDeterminedDeliveryCost = order.SelectedDelivery.NotDeterminedDeliveryCost -%}
    {% assign DepositValue = order.TotalDepositValue -%}
{% endif -%}

{% if order.NotDeterminedDeliveryCost or order.SelectedDelivery.NotDeterminedDeliveryCost -%}
    {% assign notDeterminedDeliveryCost = true -%}
{% endif -%}

{% if notDeterminedDeliveryCost and order.OrderStep == 'Start' -%}
    <div class="cart__info-bar warning-bar">{{ translations.NotDeterminedDeliveryCostInfo }}</div>
{% endif -%}

{% if order.Discount > 0 and settings.discountsPresentationInOrderSummary == 'yes' -%}
    <div class="row-summ">
        <div class="title">
            {% if include == 'offer' -%}
                {{ translations.OfferTotalPrice }}
            {% else -%}
                {{ translations.OrderTotalPrice }}
            {% endif -%}
            {% if order.SubtotalPrices -%}
                {{ translations.Netto | Downcase }}
            {% else -%}
                {{ translations.Brutto | Downcase }}
            {% endif -%}
            {{ translations.BeforeDiscount | Downcase }}
        </div>
        <span>{{ order.ProductsValueBeforeDiscount | ToPrice }} {{ order.CurrencyExt }}</span>
    </div>
    <div class="row-summ">
        <div class="title">
            {{ translations.Discount }}
        </div>
        <span>{{ order.Discount | Normalize }} %</span>
    </div>
{% endif -%}

{% if config.ENTERPRISE -%}
    <div class="row-summ">
        <div class="title">
            {% if include == 'offer' -%}
                {{ translations.OfferTotalPrice }}
            {% else -%}
                {{ translations.OrderTotalPrice }}
            {% endif -%}
            {{ translations.Netto | Downcase }}
        </div>
        <span>
            {% if include == 'offer' -%}
                {{ order.SubtotalValue | ToPrice }}
            {% else -%}
                {{ order.ProductsSubtotalValue | ToPrice }}
            {% endif -%}
            {{ order.CurrencyExt }}
        </span>
    </div>
    <div class="row-summ">
        <div class="title">
            {% if include == 'offer' -%}
                {{ translations.OfferTotalPrice }}
            {% else -%}
                {{ translations.OrderTotalPrice }}
            {% endif -%}
            {{ translations.Brutto | Downcase }}
        </div>
        <span>
            {% if include == 'offer' -%}
                {{ order.TotalValue | ToPrice }}
            {% else -%}
                {{ order.ProductsTotalValue | ToPrice }}
            {% endif -%}
            {{ order.CurrencyExt }}
        </span>
    </div>
{% else -%}
    <div class="row-summ">
        <div class="title">
            {% if include == 'offer' -%}
                {{ translations.OfferTotalPrice }}
            {% else -%}
                {{ translations.OrderTotalPrice }}
            {% endif -%}
            {% if order.SubtotalPrices -%}
                {{ translations.Netto | Downcase }}
            {% else -%}
                {{ translations.Brutto | Downcase }}
            {% endif -%}
        </div>
        <span>
            {% if order.SubtotalPrices -%}
                {{ order.ProductsSubtotalValue | ToPrice }}
            {% else -%}
                {{ order.ProductsTotalValue | ToPrice }}
            {% endif -%}
            {{ order.CurrencyExt }}
        </span>
    </div>
{% endif -%}

<div class="row-summ">
    {% if config.ENTERPRISE or order.SubtotalPrices -%}
        <div class="title">{{ translations.VatValue }}</div>
    {% else -%}
        <div class="title">{{ translations.VatIncluded }}</div>
    {% endif -%}
    <span>{{ vatValue | ToPrice }} {{ order.CurrencyExt }}</span>
</div>

{% if include == 'offer' and order.DeliveryTotalValue > 0 -%}
    <div class="row-summ">
        <div class="title">{{ translations.DelivCost }} {{ translations.Brutto | Downcase }}</div>
        <span>{{ order.DeliveryTotalValue | ToPrice }} {{ order.CurrencyExt }}</span>
    </div>
{% endif -%}

{% if order.NotDeterminedDeliveryCost == false and notDeterminedDeliveryCost == false -%}
    <div class="row-summ">
        <div class="title">{{ translations.DelivCost }}</div>
        <span>{{ deliveryCost | ToPrice }} {{ order.CurrencyExt }}</span>
    </div>
{% endif -%}

{% if paymentCost != null and order.NotDeterminedDeliveryCost == false and notDeterminedDeliveryCost == false -%}
    <div class="row-summ">
        <div class="title">{{ translations.PaymentCost }}</div>
        <span>{{ paymentCost | ToPrice }} {{ order.CurrencyExt }}</span>
    </div>
{% endif -%}

{% if DepositValue > 0 -%}
    <div class="row-summ">
        <div class="title">{{ translations.Com_Deposit }}</div>
        <span>{{ DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ order.CurrencyExt }}</span>
    </div>
{% endif -%}
`